<template>
    <invitations-store @success="onSuccess">
        <recaptcha-form
            v-model="form.recaptcha"
            slot-scope="{
                sid,
                error,
                forget,
                is_loading: is_saving,
                store
            }"
            @submit="store(form)"
        >
            <header class="flex items-center px-4 pt-3 sm:px-6 md:pt-4">
                <h1 class="text-xl font-normal font-semibold text-grey-darkest">
                    Invite your landlord
                </h1>
            </header>

            <div class="px-4 pt-6 border-b sm:px-6">
                <validator-alert :sid="sid" />

                <grid-layout>
                    <grid-layout-item>
                        <form-item
                            :sid="sid"
                            :is-required="true"
                            name="from_name"
                        >
                            <template slot="label">Your Name</template>

                            <input-text
                                v-model="form.from_name"
                                :sid="sid"
                                :autofocus="true"
                                :disabled="is_saving"
                                name="from_name"
                            />
                        </form-item>
                    </grid-layout-item>

                    <grid-layout-item>
                        <form-item
                            :sid="sid"
                            :is-required="true"
                            name="to_name"
                        >
                            <template slot="label">Landlord's Name</template>

                            <input-text
                                v-model="form.to_name"
                                :sid="sid"
                                :disabled="is_saving"
                                name="to_name"
                            />
                        </form-item>
                    </grid-layout-item>

                    <grid-layout-item>
                        <form-item
                            :sid="sid"
                            :is-required="true"
                            name="to_telephone"
                        >
                            <template slot="label">Landlord's Telephone</template>

                            <input-text
                                v-model="form.to_telephone"
                                :sid="sid"
                                :disabled="is_saving"
                                name="to_telephone"
                            />
                        </form-item>
                    </grid-layout-item>

                    <grid-layout-item>
                        <form-item
                            :sid="sid"
                            name="is_willing_to_pay"
                        >
                            <label class="flex items-center cursor-pointer">
                                <input-checkbox
                                    v-model="form.is_willing_to_pay"
                                    class="flex-none mr-3"
                                />

                                <div class="leading-tight">
                                    I'm willing to pay the small transacion fee
                                </div>
                            </label>
                        </form-item>
                    </grid-layout-item>
                </grid-layout>
            </div>

            <base-form-footer
                :is-responsive="false"
            >
                <base-button
                    :is-loading="is_saving"
                    class="w-full btn-blue"
                >
                    Submit Invitation
                </base-button>
            </base-form-footer>

            <error-modal
                v-if="error && $error.is(error, { exclude: [422] })"
                :error="error"
            />

            <modal-success
                :is-open="show_created_modal"
                @close="show_created_modal = false; forget(); reset(sid)"
            >
                <template slot="heading">Invitation sent!</template>

                <p class="mb-3">
                    Thanks for inviting your landlord!
                </p>

                <p class="mb-3">
                    We'll get in touch with them to make them aware of your interest, but ask that you also do the same.
                </p>

                <p class="mb-3">
                    Your landlord is more likely to accept the invitation if you personally contact them to express
                    your interest and reasons behind wanting to use Rentora.
                </p>

                <div
                    slot="footer"
                    slot-scope="{ close }"
                    class="flex flex-col md:flex-row-reverse"
                >
                    <button
                        type="button"
                        @click.prevent="close"
                        class="text-center btn-green btn"
                    >
                        Invite another
                    </button>
                </div>
            </modal-success>
        </recaptcha-form>
    </invitations-store>
</template>

<script>
    import HeadMixin from '../../mixins/head'
    import InvitationsStore from '../../components/invitations-store'
    import RecaptchaForm from '../../components/recaptcha-form'

    export default {
        mixins: [
            HeadMixin
        ],
        components: {
            InvitationsStore,
            RecaptchaForm
        },
        data () {
            return {
                show_created_modal: false,
                form: {
                    recaptcha: null,
                    from_name: null,
                    to_name: null,
                    to_telephone: null,
                    is_willing_to_pay: false
                }
            }
        },
        methods: {
            onSuccess () {
                this.$track(
                    'invitations.create',
                    'form-submission',
                    'A landlord has been invited'
                )

                setTimeout(() => {
                    this.show_created_modal = true
                }, 0)
            },
            reset (sid) {
                this.$validator.reset(sid)

                this.form.recaptcha = null
                this.form.to_name = null
                this.form.to_telephone = null
            },
            head () {
                return {
                    title: 'Invite your landlord',
                    description: 'Express your interest in using Rentora to your landlord'
                }
            }
        }
    }
</script>
